import type { LocaleType } from '../../../common/i18n';
import { EN_US } from './en_US';
import { RU } from './ru_RU';
import { ZH_CN } from './zh_CN';

export const Locale: LocaleType = {
  zh_CN: ZH_CN,
  en_US: EN_US,
  ru_RU: RU,
};
